import React  from 'react'

export function ContentHeader(props) {
  return (
    <React.Fragment>
      <div id="content-header">
        { (props.title) ? <div className='header-title'>{props.title}</div> : null }
        { props.children }
      </div>
      <style jsx="true">
      {`
        #content-header {
          grid-area: content-header;
          background-color: rgba(250, 250, 250, 1);
          border-bottom: solid 1px rgba(200, 200, 200, 1);
          padding: 0 10px;
          color: #00758F;
          font-family: 'Helvetica', 'Arial Rounded MT';
          font-weight: bold;
        }
        #content-header .header-title {
          font-size: 1rem;
          padding: 10px;
        }
      `}
      </style>
    </React.Fragment>
  );
}

export function ContentFooter(props) {
  return (
    <React.Fragment>
      <div id="content-footer">
        {props.children}
      </div>
      <style jsx="true">
      {`
        #content-footer {
          grid-area: content-footer;
          background-color: rgba(250, 250, 250, 1);
          border-top: solid 1px rgba(200, 200, 200, 1);
          padding: 0px 10px;
          color: black;
        }
      `}
      </style>
    </React.Fragment>
  );
}

export function ContentInner(props) {
  return (
    <React.Fragment>
      <div id='content-inner'>
        {props.children}
      </div>
      <style jsx="true">
      {`
        #content-inner {
          grid-area: content-inner;
          padding: 10px 10px;
          overflow: auto;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function Content(props) {
  return (
    <React.Fragment>
      <div id="content">
        {props.content}
      </div>
      <style jsx="true">
      {`
        #content {
          display: grid;
          grid-area: content;
          grid-template-columns: 1fr;
          grid-template-rows: auto 1fr auto;
          grid-template-areas:
              "content-header"
              "content-inner"
              "content-footer";
          overflow: auto;
        }
      `}
      </style>
    </React.Fragment>
  )
}
